import React from "react";
import { View, StyleSheet, FlatList } from "react-native";
import NtText from "../../../components/NtText";
import NtSectionTitle from "../general/NtSectionTitle";
import NtMaterialIcon from "../../../components/NtMaterialIcon";
import colors from "../../../config/colors";
import NtSectionDescription from "../general/NtSectionDescription";
import NtMarketingSectionContainer from "../general/NtMarketingSectionContainer";
import { useMobile } from "../../../hooks/useMobile";

function NtTelehealthScreeningSection({}) {
  const isMobile = useMobile();

  const data = [
    {
      icon: "heart-pulse",
      text: "Heart Rate",
      message: "Noninvasive Pulse Reading and Rhythm",
    },
    {
      icon: "lungs",
      text: "Breathing Rate",
      message: "Noninvasive Respiration Rate and Rhythm",
    },
    {
      icon: "coolant-temperature",
      text: "Body Temerature",
      message: "Core Temperature Fever Detction (coming soon)",
    },
    {
      icon: "blood-bag",
      text: "Blood Oxygen",
      message: "Sp02 Oxygen Saturation (comming soon)",
    },
    {
      icon: "clipboard-list",
      text: "Chat-Bot Questionnaire",
      message: "Based on current triage protocols used by hospitals",
    },
    {
      icon: "id-card",
      text: "Photo ID",
      message: "To ensure identity, a photo is taken during measurement",
    },
  ];

  const renderBox = (item) => {
    return (
      <View
        style={[
          {
            flex: 1,
            marginRight: 10,
            borderWidth: 1,
            borderColor: "#2c4d7a",
            backgroundColor: "#050f1d",
            borderRadius: 15,
            alignItems: "center",
            padding: 20,
          },
        ]}
      >
        <NtMaterialIcon name={item.icon} size={36} color="#006AFF" />

        <NtText
          style={{
            color: "white",
            fontSize: 16,
            fontWeight: "600",
            marginTop: 8,
            textAlign: "center",
          }}
        >
          {item.text}
        </NtText>

        <NtText
          style={{
            color: "#8493a8",
            fontSize: 14,
            fontWeight: "500",
            marginTop: 8,
            textAlign: "center",
          }}
        >
          {item.message}
        </NtText>
      </View>
    );
  };
  return (
    <NtMarketingSectionContainer
      style={[styles.container, isMobile ? { height: 750 } : {}]}
      backgroundImage={require("../../../assets/images/marketing/935118879ddeacaa7c04f342346685dc8176e711.jpg")}
    >
      <View
        style={{
          width: "100%",
          textAlign: "center",
          marginTop: 40,
        }}
      >
        <NtSectionTitle style={{ textAlign: "left" }}>
          SCREENING PROCESS
        </NtSectionTitle>
        <NtSectionDescription style={{ textAlign: "left", marginTop: 15 }}>
          The process uses the passenger’s smartphone and the cruise line’s app
          embedded with the Voxcraft system.
        </NtSectionDescription>

        <View
          style={{
            marginTop: 30,
          }}
        >
          <FlatList
            key={isMobile}
            data={data}
            renderItem={(item) => renderBox(item.item)}
            keyExtractor={(item) => item.text}
            ItemSeparatorComponent={() => <View style={{ height: 10 }} />}
            numColumns={isMobile ? 2 : 3}
            columnWrapperStyle={{ justifyContent: "center" }}
          />
        </View>
      </View>
    </NtMarketingSectionContainer>
  );
}

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    height: 450,
  },
});

export default NtTelehealthScreeningSection;
